import { useState } from "react";
import { Route, Routes } from "react-router-dom";
import { AppHeader } from "@/components/AppHeader";
import { ProviderDialog } from "@/components/ProviderDialog";
import { TooltipProvider } from "@/components/ui/tooltip";
import { ProviderVault } from "@/context/ProviderContext";
import { WalletProvider } from "@/context/WalletContext";
import { AvatarPage } from "@/pages/AvatarPage";
import { CreatePage } from "@/pages/CreatePage";
import { HomePage } from "@/pages/HomePage";

function AppShell() {
  const [providerOpen, setProviderOpen] = useState(false);
  return (
    <>
      <AppHeader onOpenProvider={() => setProviderOpen(true)} />
      <Routes>
        <Route element={<HomePage />} path="/" />
        <Route element={<CreatePage />} path="/create" />
        <Route element={<AvatarPage />} path="/avatar/:tokenId" />
      </Routes>
      <ProviderDialog onOpenChange={setProviderOpen} open={providerOpen} />
      <footer className="border-t border-white/8 px-5 py-8 text-center text-xs text-white/30">AniSoul runs without a hosted database. Verify everything on Base.</footer>
    </>
  );
}

export default function App() {
  return (
    <TooltipProvider>
      <WalletProvider>
        <ProviderVault>
          <AppShell />
        </ProviderVault>
      </WalletProvider>
    </TooltipProvider>
  );
}
